import React, { useState } from "react";
import { Form, Input } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { API_BASE_CRM_URL } from "../../Config/Config";

const { TextArea } = Input;

const AddLeadNote = ({ open, onClose, customerId, addedFrom, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const payload = {
        rel_id: customerId,
        rel_type: "Lead",
        description: values.description,
        addedfrom: addedFrom,
      };

      const response = await axios.post(
        `${API_BASE_CRM_URL}notes/AddNote`,
        payload,
      );

      if (response.data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.Message,
          confirmButtonColor: "#1B2850",
        });

        form.resetFields();

        if (onSuccess) {
          onSuccess();
        }

        onClose();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.Message,
          confirmButtonColor: "#1B2850",
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: error?.response?.data?.Message || "Failed to add note",
        confirmButtonColor: "#1B2850",
      });
    }
  };

  return (
    <>
      {open && (
        <>
          <div
            className="offcanvas offcanvas-bottom show"
            style={{
              visibility: "visible",
              height: "40vh",
              zIndex: 1055,
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
              backgroundColor: "#fff",
            }}
          >
            {/* Drag Handle */}
            <div className="text-center pt-2">
              <div
                style={{
                  width: "50px",
                  height: "5px",
                  background: "#ccc",
                  borderRadius: "10px",
                  margin: "0 auto",
                }}
              />
            </div>

            {/* Header */}
            <div className="offcanvas-header border-bottom d-flex justify-content-between align-items-center">
              <h5
                className="mb-0"
                style={{
                  color: "#1B2850",
                  fontWeight: "600",
                }}
              >
                <i className="fa-solid fa-note-sticky me-2"></i>
                Add Lead Note
              </h5>

              <div className="d-flex gap-2">
                {/* Close */}
                <div
                  onClick={onClose}
                  style={{
                    width: "38px",
                    height: "38px",
                    background: "#fff",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                  }}
                >
                  <i
                    className="fa-solid fa-xmark"
                    style={{
                      color: "#dc3545",
                      fontSize: "16px",
                    }}
                  />
                </div>

                {/* Save */}
                <div
                  onClick={() => form.submit()}
                  style={{
                    width: "38px",
                    height: "38px",
                    background: "#fff",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                  }}
                >
                  <i
                    className={`fa-solid ${
                      loading ? "fa-spinner fa-spin" : "fa-check"
                    }`}
                    style={{
                      color: "#198754",
                      fontSize: "16px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="offcanvas-body">
              <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Form.Item
                  label="Notes"
                  name="description"
                  rules={[
                    {
                      required: true,
                      message: "Please enter notes",
                    },
                  ]}
                >
                  <TextArea
                    rows={6}
                    placeholder="Enter customer notes..."
                    maxLength={1000}
                    showCount
                  />
                </Form.Item>
              </Form>
            </div>
          </div>

          {/* Backdrop */}
          <div className="offcanvas-backdrop fade show" onClick={onClose} />
        </>
      )}
    </>
  );
};

export default AddLeadNote;
